/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FeeVo
 */
export interface FeeVo {
    /**
     * 服务类型及保存时的显示名称。
     * @type {number}
     * @memberof FeeVo
     */
    feeType?: number;
    /**
     * 
     * @type {string}
     * @memberof FeeVo
     */
    feeTypeName?: string;
    /**
     * 保存时的选项、数量、单价、实际费用及折扣，不按当前配置重算。
     * @type {string}
     * @memberof FeeVo
     */
    option?: string;
    /**
     * 
     * @type {number}
     * @memberof FeeVo
     */
    count?: number;
    /**
     * 
     * @type {number}
     * @memberof FeeVo
     */
    unitPrice?: number;
    /**
     * 
     * @type {number}
     * @memberof FeeVo
     */
    totalAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof FeeVo
     */
    discount?: number;
    /**
     * 来源物料及仓库，供追溯使用。
     * @type {number}
     * @memberof FeeVo
     */
    materialId?: number;
    /**
     * 
     * @type {number}
     * @memberof FeeVo
     */
    warehouseId?: number;
}

/**
 * Check if a given object implements the FeeVo interface.
 */
export function instanceOfFeeVo(value: object): value is FeeVo {
    return true;
}

export function FeeVoFromJSON(json: any): FeeVo {
    return FeeVoFromJSONTyped(json, false);
}

export function FeeVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FeeVo {
    if (json == null) {
        return json;
    }
    return {
        
        'feeType': json['feeType'] == null ? undefined : json['feeType'],
        'feeTypeName': json['feeTypeName'] == null ? undefined : json['feeTypeName'],
        'option': json['option'] == null ? undefined : json['option'],
        'count': json['count'] == null ? undefined : json['count'],
        'unitPrice': json['unitPrice'] == null ? undefined : json['unitPrice'],
        'totalAmount': json['totalAmount'] == null ? undefined : json['totalAmount'],
        'discount': json['discount'] == null ? undefined : json['discount'],
        'materialId': json['materialId'] == null ? undefined : json['materialId'],
        'warehouseId': json['warehouseId'] == null ? undefined : json['warehouseId'],
    };
}

export function FeeVoToJSON(json: any): FeeVo {
    return FeeVoToJSONTyped(json, false);
}

export function FeeVoToJSONTyped(value?: FeeVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'feeType': value['feeType'],
        'feeTypeName': value['feeTypeName'],
        'option': value['option'],
        'count': value['count'],
        'unitPrice': value['unitPrice'],
        'totalAmount': value['totalAmount'],
        'discount': value['discount'],
        'materialId': value['materialId'],
        'warehouseId': value['warehouseId'],
    };
}

